import React from 'react'
import { Button, Form, Input, P, A, Icon } from '@drifthq/tide-core'
import { Link } from 'react-router-dom'
import './styles.css'

const FindMyTeamVerify = ({
  email,
  onEmailChange,
  onContinueClick,
  sentEmail,
}) => {
  return (
    <Form className="touchless-start-fields" onSubmit={onContinueClick}>
      <h1 className="find-my-team-header">Find your Drift organization</h1>
      <P className="find-my-team-verification-copy">We’ll send you a verification email to confirm your email address and find existing Drift organizations you can join.</P>
      <Input
        placeholder="enter your email"
        value={email}
        size="large"
        className="email-verify-input"
        onChange={onEmailChange}
      />
      <Button
        submit
        size="large"
      >
        Send verification email
      </Button>
      {sentEmail === 'failure' &&
        <P className="existing-user-error"> An existing user with that email already exists </P>
      }
      <Link
        className="step-back-link"
        to={{ pathname: "/start" }}>
        <Icon width={7} name="arrow-1-left" />
        <A>Back</A>
      </Link>
    </Form>
  )
}

export default FindMyTeamVerify



// WEBPACK FOOTER //
// ./src/layouts/FindMyTeam/FindMyTeamVerify/component.js